import { gql } from "@apollo/client";
import {
  FRAGMENT_INTEGRATIONS_SCREEN_PARTS,
  FRAGMENT_MEMBER_LIST_PARTS,
} from "./fragment";

export const MUTATION_ADD_COMPANY_MEMBER = gql`
  mutation CompanyPortalMemberAdd(
    $appInfo: AppInfo!
    $input: CompanyPortalMemberAddInput!
  ) {
    companyPortalMemberAdd(appInfo: $appInfo, input: $input) {
      ok
      companyAdmin {
        membersScreen {
          title
          subTitle
          labels
          searchQuery
          uploadButton {
            buttonAction
            buttonText
            buttonStyle
          }
          addButton {
            buttonAction
            buttonText
            buttonStyle
          }

          statusSort
          members {
            ...MembersListParts
          }
        }
      }
    }
  }
  ${FRAGMENT_MEMBER_LIST_PARTS}
`;

export const MUTATION_DEACTIVATE_COMPANY_MEMBER = gql`
  mutation CompanyPortalMemberDeactivate(
    $appInfo: AppInfo!
    $memberUserId: ID!
  ) {
    companyPortalMemberDeactivate(
      appInfo: $appInfo
      memberUserId: $memberUserId
    ) {
      ok
      companyAdmin {
        membersScreen {
          title
          subTitle
          labels
          searchQuery
          uploadButton {
            buttonAction
            buttonText
            buttonStyle
          }
          addButton {
            buttonAction
            buttonText
            buttonStyle
          }

          statusSort
          members {
            ...MembersListParts
          }
        }
      }
    }
  }
  ${FRAGMENT_MEMBER_LIST_PARTS}
`;
export const MUTATION_REACTIVATE_COMPANY_MEMBER = gql`
  mutation CompanyPortalMemberReactivate(
    $appInfo: AppInfo!
    $memberUserId: ID!
  ) {
    companyPortalMemberReactivate(
      appInfo: $appInfo
      memberUserId: $memberUserId
    ) {
      ok
      companyAdmin {
        membersScreen {
          title
          subTitle
          labels
          searchQuery
          uploadButton {
            buttonAction
            buttonText
            buttonStyle
          }
          addButton {
            buttonAction
            buttonText
            buttonStyle
          }

          statusSort
          members {
            ...MembersListParts
          }
        }
      }
    }
  }
  ${FRAGMENT_MEMBER_LIST_PARTS}
`;
export const MUTATION_SEND_INVITE_COMPANY_MEMBER = gql`
  mutation CompanyPortalMemberSendInvite(
    $appInfo: AppInfo!
    $memberUserId: ID!
  ) {
    companyPortalMemberSendInvite(
      appInfo: $appInfo
      memberUserId: $memberUserId
    ) {
      ok
      companyAdmin {
        membersScreen {
          title
          subTitle
          labels
          searchQuery
          uploadButton {
            buttonAction
            buttonText
            buttonStyle
          }
          addButton {
            buttonAction
            buttonText
            buttonStyle
          }
          totalPages
          itemsPerPage
          pageNumber
          statusSort
          members {
            ...MembersListParts
          }
        }
      }
    }
  }
  ${FRAGMENT_MEMBER_LIST_PARTS}
`;

export const MUTATION_ADD_COMPANY_DOMAIN = gql`
  mutation CompanyPortalDomainAdd($appInfo: AppInfo!, $domain: String!) {
    companyPortalDomainAdd(appInfo: $appInfo, domain: $domain) {
      ok
      companyAdmin {
        integrationsScreen {
          ...IntegrationsScreenParts
        }
      }
    }
  }
  ${FRAGMENT_INTEGRATIONS_SCREEN_PARTS}
`;

export const MUTATION_REMOVE_COMPANY_DOMAIN = gql`
  mutation CompanyPortalDomainRemove($appInfo: AppInfo!, $domain: String!) {
    companyPortalDomainRemove(appInfo: $appInfo, domain: $domain) {
      ok
      companyAdmin {
        integrationsScreen {
          ...IntegrationsScreenParts
        }
      }
    }
  }
  ${FRAGMENT_INTEGRATIONS_SCREEN_PARTS}
`;

export const MUTATION_SSO_UPDATE = gql`
  mutation CompanyPortalSignInOptionUpdate(
    $appInfo: AppInfo!
    $input: CompanyPortalSignInOptionSettingsInput!
  ) {
    companyPortalSignInOptionUpdate(appInfo: $appInfo, input: $input) {
      ok
      companyAdmin {
        integrationsScreen {
          ...IntegrationsScreenParts
        }
      }
    }
  }
  ${FRAGMENT_INTEGRATIONS_SCREEN_PARTS}
`;

export const MUTATION_SELF_SIGN_UP_UPDATE = gql`
  mutation CompanyPortalSelfSignUpUpdate(
    $appInfo: AppInfo!
    $isSignUpEnabled: Boolean!
  ) {
    companyPortalSelfSignUpUpdate(
      appInfo: $appInfo
      isSignUpEnabled: $isSignUpEnabled
    ) {
      ok
      companyAdmin {
        integrationsScreen {
          ...IntegrationsScreenParts
        }
      }
    }
  }
  ${FRAGMENT_INTEGRATIONS_SCREEN_PARTS}
`;

export const MUTATION_REMOVE_HRIS = gql`
  mutation CompanyPortalHRISRemove($appInfo: AppInfo!, $hrisConnectionId: ID!) {
    companyPortalHrisRemove(
      appInfo: $appInfo
      hrisConnectionId: $hrisConnectionId
    ) {
      ok
      companyAdmin {
        integrationsScreen {
          ...IntegrationsScreenParts
        }
      }
    }
  }
  ${FRAGMENT_INTEGRATIONS_SCREEN_PARTS}
`;

export const MUTATION_ADD_ADMIN = gql`
  mutation CompanyPortalAdminAdd($appInfo: AppInfo!, $memberUserId: ID!) {
    companyPortalAdminAdd(appInfo: $appInfo, memberUserId: $memberUserId) {
      ok
    }
  }
`;

export const MUTATION_REMOVE_ADMIN = gql`
  mutation CompanyPortalAdminRemove($appInfo: AppInfo!, $adminUserId: ID!) {
    companyPortalAdminRemove(appInfo: $appInfo, adminUserId: $adminUserId) {
      ok
    }
  }
`;
